import React, { useEffect, useState } from "react";
import "./PopupModal.css"; // Add your styles here
import alertIcon from "./asserts/hacker.jpg"; // Import the fraud alert icon
import exclamatoryIcon from "./asserts/exclamatory.png"; // Import the exclamatory icon

const PopupModal = ({ isOpen, onClose, message, handleSubmit }) => {
  const [showModal, setShowModal] = useState(isOpen);
  const [isAborted, setIsAborted] = useState(false); // State to track if the transaction is aborted

  // This useEffect ensures the modal state updates whenever the `isOpen` prop changes.
  useEffect(() => {
    setShowModal(isOpen); // Updates showModal state based on isOpen prop
    setIsAborted(false); // Reset aborted state when modal is reopened
  }, [isOpen]); // Re-run the effect when `isOpen` prop changes

  const handleClose = () => {
    setShowModal(false);
    onClose && onClose(false); // Notify parent to close modal
  };

  const handleConfirm = () => {
    setShowModal(false);
    onClose && onClose(true); // Notify parent that action is confirmed
    handleSubmit(); // Call handleSubmit when "Yes" is clicked
  };

  const handleAbort = () => {
    setIsAborted(true); // Set aborted state to true when No is clicked
  };

  if (!showModal) return null; // Return null when modal isn't open

  return (
    <div className="popup-modal-overlay">
      <div className="popup-modal">
        {/* Conditionally render fraud alert only when transaction is not aborted */}
        {!isAborted && (
          <div>
            {/* Alert Icon */}
            <img
              src={alertIcon} // Use the imported fraud alert image
              alt="Alert Icon"
              className="alert-icon"
            />
            <h2 className="fraud-alert">FRAUD ALERT!</h2>
            <h3>
              The beneficiary account has a history of fraudulent activity.
            </h3>
            <h4>Proceed with caution</h4>
          </div>
        )}

        {/* Conditionally render exclamatory icon when transaction is aborted */}
        {isAborted && (
          <div>
            <img
              src={exclamatoryIcon} // Use the imported exclamatory icon
              alt="Exclamation Icon"
              className="exclamatory-icon"
            />
          </div>
        )}

        {/* Dynamic message */}
        <h1 className="popup-modal-message">
          {isAborted ? "Transaction aborted" : message}
        </h1>

        {/* Show transaction aborted message if isAborted is true */}

        <div className="popup-modal-buttons">
          {!isAborted ? (
            <>
              <button className="popup-modal-btn" onClick={handleClose}>
                Yes
              </button>
              <button className="popup-modal-btn" onClick={handleAbort}>
                No
              </button>
            </>
          ) : (
            <button className="popup-modal-btn" onClick={handleClose}>
              Close
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default PopupModal;
